/****************
 * A KEY REFUSED WHEN IT IS CONNECTED: WHAT THE ORB SAYS. 2026-10-25.
 *
 * Guillaume asked for second-time reactions to errors. The first refusal gets
 * the general walk-through (it was the only answer before). The SECOND refusal
 * of the same kind gets help for that kind: an IP list, a bad signature, the
 * trading permission, an expired key, a testnet/live mix-up, a wrong
 * passphrase. A refusal because the exchange could not be reached is never
 * the person's key: the Orb says so, with no "fix your key" walk-through.
 *
 * Pure, so a test drives it. Twin: frontend/src/lib and mobile-app/src/lib.
 ****************/

export type KeyRefusalClass =
  | 'invalid_signature' | 'ip_whitelist' | 'permissions' | 'expired'
  | 'testnet_mismatch' | 'passphrase' | 'network' | 'unknown';

export interface KeyRefusalNudge {
  trigger: string;
  messageKey: string;
  bubbleKey: string;
  guide?: string;
}

/** What the Orb raises for the nth refusal (1-based) of this kind in this visit. */
export function keyRefusalNudge(cls: KeyRefusalClass, nth: number): KeyRefusalNudge {
  if (cls === 'network') {
    return { trigger: 'key-network', messageKey: 'orb.live.keyNetwork.message', bubbleKey: 'orb.live.keyNetwork.bubble' };
  }
  if (nth >= 2 && cls !== 'unknown') {
    return {
      trigger: `key-refused-${cls}`,
      messageKey: `orb.live.keyRefused.${cls}.message`,
      bubbleKey: `orb.live.keyRefused.${cls}.bubble`,
      guide: 'connect-exchange',
    };
  }
  return { trigger: 'key-refused', messageKey: 'orb.live.keyRefused.message', bubbleKey: 'orb.live.keyRefused.bubble', guide: 'connect-exchange' };
}

const seen = new Map<string, number>();

/** Counts this kind's refusals in this visit and says what to raise. */
export function nextKeyRefusalNudge(cls: KeyRefusalClass): KeyRefusalNudge {
  const n = (seen.get(cls) ?? 0) + 1;
  seen.set(cls, n);
  return keyRefusalNudge(cls, n);
}
